export interface ToastPayload {
  title: string;
  description: string;
}

export interface Toast {
  id: string;
  title: string;
  description: string;
  type: ToastType;
}

export enum ToastType {
  Success,
  Error
}
